import qs from 'qs'
import axios, {
  AxiosError,
  AxiosPromise,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios'
import merge from 'lodash.merge'
import { Get } from './Get'
import { Put } from './Put'
import { Post } from './Post'
// import {env} from '../Application';
import { UserPreferencesData, RegisterUserData } from './UserService.d'
import { store } from '~/Store'
import { UserSelectors } from '~/Store/User'
import { Delete } from './Delete'

export interface ClaimResponse {
  guid: string
  claimType: string
  claimValue: string
  productId: string
  product?: any
  rolesProductClaims?: any
  userProductClaims?: any
  licenseTypeProductClaims?: any
}

export interface ProductClaim {
  productId: string
  claimType: string
  claimValue: string
}

class UserServiceController {
  private licenseManagerUrl =
    process.env.LICENSE_MANAGER_URL ??
    window.location.protocol +
      '//' +
      window.location.hostname +
      '/license_manager'

  private identityServerUrl =
    process.env.IDENTITY_SERVER_URL ??
    window.location.protocol + '//' + window.location.hostname + '/identity'

  public Put = {
    updateProductClaim: (
      productClaimId: string,
      input: ProductClaim,
      options: AxiosRequestConfig = {},
    ) =>
      Put(`${this.licenseManagerUrl}/Claims/${productClaimId}`, input, options),
  }

  public Get = {
    getClaims: (
      options: AxiosRequestConfig = {},
    ): AxiosPromise<ClaimResponse | AxiosError> =>
      Get(`${this.licenseManagerUrl}/Claims`, options),
  }

  public Post = {
    addNewProductClaim: (
      input: ProductClaim,
      options: AxiosRequestConfig = {},
    ) => Post(`${this.licenseManagerUrl}/Claims`, input, options),
  }

  public Delete = {}
}

export const ClaimService = new UserServiceController()
